export const NavbarData = [
    {
        name: "Home",
        href: "/"
    },
    {
        name: "Menu",
        href: "/menu"
    },
    {
        name: "Contact",
        href: "/contact"
    },
]